<script>
import { mapGetters, mapState } from "vuex";
import QuizPassed from "./quiz_passed.vue";
import QuizTake from "./quiz_take.vue";
import Results from "./results.vue";
import QuizFinish from "./quiz_finish.vue";

export default {
  name: "QuizPlayer",
  computed: {
    ...mapGetters(["take"]),
    ...mapState(["isStudyGuide", "showSuccessBanner"]),
    quizPassed() {
      return this.take.quiz_passed;
    }
  },
  components: {
    QuizPassed,
    QuizTake,
    Results,
    QuizFinish
  },
  props: {
    loggedIn: Boolean,
    target: Object,
    nextUrl: String
  },

  render: function(createElement) {
    const innerComponents = [];

    const props = {
      props: {
        loggedIn: this.loggedIn,
        target: this.target,
        nextUrl: this.nextUrl
      }
    };

    if (this.quizPassed && this.showSuccessBanner) {
      innerComponents.push(createElement("QuizPassed", props));
    } else if (this.quizPassed) {
      if (this.isStudyGuide) {
        innerComponents.push(createElement("Results"));
      } else {
        innerComponents.push(createElement("QuizFinish", props));
      }
    } else {
      innerComponents.push(createElement("quiz-take", { props: { loggedIn: props.loggedIn } }));
    }
    return createElement(
      "div",
      { class: "quiz-player-block" },
      innerComponents
    );
  }
};
</script>
